import RegistrationForm from '../../components/RegistrationForm';
import CourseList from '../../components/CourseList';
import { useCourses } from '../../contexts/CourseContext';
import type { IContact } from '../../interfaces/IContact';
import type { ICourse } from '../../interfaces/ICourse';

interface ICourseObj {
    course: ICourse;
    subscribes: IContact[];
    nbSubscribes: number;
}

interface CourseContextType {
    list: ICourseObj[];
    loading: boolean;
}

const Inscription = () => {
    const courseContext: CourseContextType = useCourses();

    return (
        <div id="Inscription">
            <div id="title">
                <h1>Inscription aux cours</h1>
            </div>
            {
                courseContext.loading ?
                    <p>Chargement en cours...</p>
                    :
                    courseContext.list.length > 0 ?
                        <div className="flex flex-wrap flex-space-between">
                            <RegistrationForm stages={undefined} courses={courseContext.list} title="Choisir votre cours" />
                            <CourseList stages={undefined} courses={courseContext.list} title="Liste des cours" />
                        </div>
                        :
                        <div>
                            <p>Le système d'inscription est actuellement en panne.</p>
                        </div>
            }
        </div>
    )
};

export default Inscription;
